import {component_tool} from '@/tool';
import React from 'react';
import {WizTableForm} from "../../common";

import ThirdCorpUserSave from './save'
import ThirdCorpUserImport from "./thirdCorpUserImport";

let {WizModal, WizPopover} = component_tool;
//配置项
let componentName = 'thirdCorpUser'

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      name: "personId",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      searchItem: {},
      tableItem: {},
      formItem: {
        disabled: true,
      },
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {},
      tableItem: {},
      formItem: {
        disabled: true,
      },
    },
    {
      title: "证件号码",
      name: "idCard",
      dataIndex: "idCard",
      searchItem: {},
      tableItem: {},
      formItem: {
        disabled: true,
      },
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      dict: [
        {code: 1, codeName: "激活"},
        {code: 0, codeName: "禁用"}
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {},
      formItem: {
        type: 'select',
        disabled: true,
      },
    },
    {
      title: "手机号",
      name: "mobile",
      dataIndex: "mobile",
      tableItem: {}
    },
    {
      title: "组织机构",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig
      }
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },
    {
      title: "任职信息",
      name: "identityInfos",
      dataIndex: "identityInfos",
      tableItem: {
        render: (val = [], record) => {
          if (!val.length) {
            return '暂无任职'
          }
          let {orgName, positionName} = val[0]
          let _titleView = [`${orgName}-${positionName}`]
          if (val.length > 1) {
            _titleView.push(<span className="manager-person-text-color"> ...</span>)
          }

          return (
            <WizPopover content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)} placement="rightTop">
              {_titleView}
            </WizPopover>
          );
        }
      }
    },
    {
      title: "企业账号状态",
      name: "corpUserState",
      dataIndex: "corpUserState",
      dict: [
        {code: 1, codeName: "是"},
        {code: 0, codeName: "否"}
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {},
    },
    {
      title: "企业内账号",
      name: "userId",
      dataIndex: "userId",
      searchItem: {},
      tableItem: {},
      formItem: {
        rules: [
          { required: true, message: '请输入企业内账号' },
        ],
      },
    },
    {
      title: "openId",
      name: "openId",
      dataIndex: "openId",
      tableItem: {},
      formItem: {},
    },
  ]
};

const templateConfig = (self) => {
  let corpInfoId = self.record.id;
  return  {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 12
          },
          buttonSort: ['import', 'export'],
          buttons: [
            {
              key: "import",
              custom: true,
              params: { icon: 'import', children: '导入', type: 'import'},
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "导入第三方企业账号",
                    diy: (e) => (
                      <ThirdCorpUserImport {...e} key={new Date()} corpInfoId={corpInfoId}/>
                    ),
                    footer: false,
                    width: 1000
                  }
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter }
                }
              }
            },
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['edit'],
        rowOperateView: [
          {
            key: "edit",
            custom: true,
            params: { children: "设置" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "设置",
                  diy: (e) => {
                    return <ThirdCorpUserSave key={e.record.id} corpInfoId={corpInfoId} {...e} />
                  },
                  width: 700,
                  footer: null,
                },
              }
            },
          },
        ],
        commonOperate: {}
      }
    }
  }
};

const apis = (self) => {
  let corpInfoId = self.record.id;
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {
          corpInfoId: corpInfoId
        }
      }
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {
          corpInfoId: corpInfoId
        }
      }
    },
  }
}


let reduxTemplateConfig = (self, args) => {
  return {
    apis: apis(self),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
